import { DateTime } from "luxon";
import { useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";

export default function LocationCard(props) {
  const currentLocation = props.currentLocation;
  const setCurrentLocation = props.setCurrentLocation;

  function parseSeniorDivision(data) {
    let locationFound = false;

    let now = DateTime.now();

    let currentDay = now.toFormat("EEEE").toUpperCase();

    console.log(currentDay);

    let findCorrectTime = function (index) {
      for (let i in data[index]) {
        if (
          data[index][i] == "Time" ||
          data[index][i] == "Short Friday" ||
          data[index][i].length == 0
        )
          continue;

        let startDateTime = DateTime.fromFormat(
          data[index][i].split("-")[0].trim(),
          "h:mm"
        );

        // If the time is before 9 AM, convert it to PM
        if (startDateTime.isValid && startDateTime.hour < 9) {
          startDateTime = startDateTime.plus({ hours: 12 });
        }

        let endDateTime = DateTime.fromFormat(
          data[index][i].split("-")[1].trim(),
          "h:mm"
        );
        // If the time is before 9 AM, convert it to PM
        if (endDateTime.isValid && endDateTime.hour < 9) {
          endDateTime = endDateTime.plus({ hours: 12 });
        }

        if (startDateTime < now && endDateTime > now) {
          console.log(data[index][i]);

          const classRow = data.find((row) => {
            return (
              row[0] == currentDay &&
              (row[2] == props.studentClass ||
                row[2] == props.studentClass + "E") //himel east
            );
          });

          console.log(classRow);

          return [classRow, i];
        }
      }
    };

    let [classRow, i] = findCorrectTime(1);

    if (classRow) {
      let newIndex = parseInt(i) + 1;

      let sfRow = "";

      if (currentDay == "FRIDAY") {
        let sfIndex = findCorrectTime(2)[1];
        let newSfIndex = parseInt(sfIndex) + 1;
        sfRow = ` \n\n Short Friday: ${classRow[newSfIndex].replaceAll(
          "\n",
          "/"
        )} (${classRow[sfIndex].replaceAll("\n", " ")})`;
      }

      let stringLocation = `${classRow[newIndex].replaceAll(
        "\n",
        "/"
      )} (${classRow[i].replaceAll("\n", " ")}) ${sfRow}`;

      if (classRow[i].toUpperCase().trim() == "RECESS") {
        stringLocation = "Recess";
      }

      setCurrentLocation(stringLocation);
      locationFound = true;
    }

    if (!locationFound) {
      setCurrentLocation("noclass");
    }
  }

  useEffect(() => {
    const abortController = new AbortController();

    const fetchData = async () => {
      setCurrentLocation("loading");
      let attempts = 0;
      while (attempts < 4 && !abortController.signal.aborted) {
        try {
          let newToken = await props.refreshToken();
          let appCheckToken = await props.getAppCheckToken();

          const response = await fetch(
            "https://teacher-dashboard-427618.nn.r.appspot.com/getClassSchedule",
            {
              method: "GET",
              headers: {
                "X-Authorization-Token": newToken,
                "X-Firebase-AppCheck": appCheckToken.token,
                "Selected-Class": props.studentClass,
              },
              signal: abortController.signal,
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();

          console.log(data);

          if (props.studentClass[0] >= 6) {
            parseSeniorDivision(data);
          }

          break;
        } catch (error) {
          // Don't log or update state if the request was aborted due to component unmounting
          if (error.name === "AbortError") {
            return;
          }

          console.error("Attempt to fetch data failed:", error);
          attempts += 1;

          setCurrentLocation("noclass");

          // If this was the last attempt, throw the error
          if (attempts >= 4) {
            console.error("Failed to fetch data after 4 attempts:", error);
          }
        }
      }
    };

    fetchData();

    // Cleanup function to abort the fetch when component unmounts
    return () => {
      abortController.abort();
    };
  }, [props.studentName]);

  return (
    <Card sx={{ marginBottom: "20px", marginLeft: "7px", marginRight: "7px" }}>
      <CardContent>
        <Typography gutterBottom variant="h6" sx={{ fontSize: "1rem" }}>
          Where is {props.studentName}?
        </Typography>

        <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
          {currentLocation == "loading" ? <Skeleton /> : currentLocation}
        </Typography>
      </CardContent>
    </Card>
  );
}
